// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trackList_root__2Ab9a {\n  height: calc(100% - 60px);\n  overflow-y: auto; }\n", ""]);
// Exports
exports.locals = {
	"root": "trackList_root__2Ab9a"
};
module.exports = exports;
